import script from "./RTCStats.vue?vue&type=script&lang=ts&setup=true"
export * from "./RTCStats.vue?vue&type=script&lang=ts&setup=true"

import "./RTCStats.vue?vue&type=style&index=0&id=2b91f7e2&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2b91f7e2"]])

export default __exports__